import { defineStore } from 'pinia';
import http from '../api/httpRequest.js'
import { setFaviconFromCompanyLogo } from '../utils/favicon.js'
// import { setTitleTip } from '../api/element.js'

export default defineStore('configStore', {
	state: () => {
		return {
			appInit: false,  // 应用是否完成初始化
			electronMode: false, // 当前是否以客户端模式运行
			fullScreen: true, // 当前是否全屏
			registration: {
				mode: []
			},
			webrtc: {},
			companyLogo: null,
			companyName: null,
			information: null
		}
	},
	actions: {
		setConfig(config) {
			this.webrtc = config.webrtc;
			this.registration = config.registration;
			this.companyLogo = config.companyLogo;
			this.companyName = config.companyName;
			this.information = config.information
			setFaviconFromCompanyLogo(this.companyLogo)

		},
		setElectronMode(mode) {
			this.electronMode = mode
		},
		setFullScreen(fullScreen) {
			this.fullScreen = fullScreen;
		},
		setAppInit(appInit) {
			this.appInit = appInit;
		},
		switchFullScreen() {
			this.fullScreen = !this.fullScreen;
		},
		loadConfig() {
			return new Promise((resolve, reject) => {
				http({
					url: '/system/config',
					method: 'GET'
				}).then(config => {
					console.log("系统配置", config)
					this.setConfig(config);
					resolve();
				}).catch((res) => {
					reject(res);
				});
			})
		}
	}
});